import { ReactNode } from 'react'

import { PickerMenuSearch } from '../../../../base'
import { Loading } from '../../../Loading'
import * as S from '../../CheckPicker.styles'

interface SelectionMenuProps extends PickerMenuSearch {
  menu: ReactNode
  header: ReactNode
  isLoading?: boolean
  searchable: boolean
}

export const SelectionMenu = ({
  menu,
  header,
  isLoading,
  searchable,
  searchKeyword,
  clearSearch,
}: SelectionMenuProps) => (
  <S.CustomMenu>
    {isLoading ? (
      <S.LoadingContainer>
        <Loading size="4px" />
      </S.LoadingContainer>
    ) : (
      <>
        {searchable ? <S.SearchBarMagIcon /> : null}
        {searchKeyword ? <S.SearchBarClearIcon onClick={clearSearch} /> : null}
        {header}
        {menu}
      </>
    )}
  </S.CustomMenu>
)
